webpackJsonp([9],{

/***/ 136:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__frame_subroute_vue__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__frame_subroute_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__frame_subroute_vue__);



/* harmony default export */ __webpack_exports__["a"] = ([{
  path: "*",
  redirect: '/hnmj/index'
}, {
  path: "/coinState",
  name: '/coinState',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(7).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(382)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/privacy",
  name: '/privacy',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(6).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(387)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/question",
  name: '/question',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(4).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(388)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/playState",
  name: '/playState',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(3).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(386)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/userAgreement",
  name: '/userAgreement',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(5).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(389)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: "/master",
  name: '/master',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(2).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(385)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/douniu',
  component: __WEBPACK_IMPORTED_MODULE_0__frame_subroute_vue___default.a,
  children: [{
    path: 'index',
    name: 'inedx',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(0).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(383)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }]
}, {
  path: '/hnmj',
  component: __WEBPACK_IMPORTED_MODULE_0__frame_subroute_vue___default.a,
  children: [{
    path: 'index',
    name: 'inedx',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(1).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(384)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }]
}]);

/***/ }),

/***/ 138:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 141:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(93)(
  /* script */
  __webpack_require__(161),
  /* template */
  __webpack_require__(376),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 143:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_weixin_js_sdk__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_weixin_js_sdk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_weixin_js_sdk__);
//正式需修改部分
global.getQpServer = function (){
	var domain;
	if(document.domain == 'www.leba.com' || document.domain == 'tg.leba.com' || document.domain == 'dnh5.leba.com' || document.domain == 'wxtg.leba.com'){	//外网
		domain = 'https://dnapi.leba.com/index.php';
	}else if(document.domain == 'dnh5test1.leba.com'){	//预发布环境
		domain = 'https://dntest1api.leba.com/index.php';
	}else if(document.domain == 'dnh5test.leba.com'){	//测试
		domain = 'https://dntest201api.leba.com/index.php';
	}else{	//开发
		domain = 'https://api.mj.5sm.com/index.php';
	}
	return domain;
}

global.getHeadUrl = function (){
	var domain;
	if(document.domain == 'www.leba.com' || document.domain == 'tg.leba.com' || document.domain == 'dnh5.leba.com' || document.domain == 'wxtg.leba.com'){	//外网
		domain = 'https://dnapi.leba.com/index.php';
	}else if(document.domain == 'dnh5test1.leba.com'){	//预发布环境
		domain = 'https://dntest1api.leba.com/index.php';
	}else if(document.domain == 'dnh5test.leba.com'){	//测试
		domain = 'https://dntest201api.leba.com/index.php';
	}else{	//开发
		domain = 'http://172.29.151.206:90/';
	}
	return domain;
}

//分享网页时请求图标用
global.getHost = function (serverType){
	var domain;
	if(document.domain == 'www.leba.com'){	//外网1
		domain = 'https://www.leba.com';
	}else if(document.domain == 'tg.leba.com'){	//外网2
		domain = 'https://tg.leba.com';
	}else if(document.domain == 'dnh5.leba.com'){	//外网3
		domain = 'https://dnh5.leba.com';
	}else if(document.domain == 'wxtg.leba.com'){	//外网4
		domain = 'https://wxtg.leba.com';
	}else if(document.domain == 'dnh5test1.leba.com'){	//预发布环境
		domain = 'https://dnh5test1.leba.com';
	}else if(document.domain == 'dnh5test.leba.com'){	//测试
		domain = 'https://dnh5test.leba.com';
	}else{	//开发
		domain = 'https://172.29.151.206:96';
	}
	return domain;
}
//微信分享

global.getWXJS=function(context,shareTitle,shareLink,shareContent){
	if (isWeiXin) {
		var _this=context;
		var href = window.location.href;
		href = encodeURIComponent(href);
		var url=getQpServer()+'/H5/weixin/weixinInfo?url='+href;
		_this.$ajax({
			method : 'get',
			url : url,
		}).then(function(response){
			if (response.data.success == 1) {
				var data=response.data.data;
				__WEBPACK_IMPORTED_MODULE_0_weixin_js_sdk___default.a.config({
					debug: false,
    						appId: data.appId, // 必填，公众号的唯一标识
    						timestamp: data.timestamp, // 必填，生成签名的时间戳
    						nonceStr: data.noncestr, // 必填，生成签名的随机串
    						signature: data.signature,// 必填，签名，见附录1
    						jsApiList: ['onMenuShareTimeline','onMenuShareAppMessage'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
    					});
				__WEBPACK_IMPORTED_MODULE_0_weixin_js_sdk___default.a.ready(function(){
					__WEBPACK_IMPORTED_MODULE_0_weixin_js_sdk___default.a.onMenuShareTimeline({
    							title: shareContent, // 分享标题
    							link: shareLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
   								imgUrl: getHost()+'/ic_launcher.png', // 分享图标
   								success: function () { 
   								},
   								cancel: function () { 
   								}
   							});
					__WEBPACK_IMPORTED_MODULE_0_weixin_js_sdk___default.a.onMenuShareAppMessage({
    							title: shareTitle, // 分享标题
    							desc: shareContent, // 分享描述
    							link: shareLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
    							imgUrl: getHost()+'/ic_launcher.png', // 分享图标
    							type: 'link', // 分享类型,music、video或link，不填默认为link
    							dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
    							success: function () { 
    							},
    							cancel: function () { 
    							}
    						});
				});
				__WEBPACK_IMPORTED_MODULE_0_weixin_js_sdk___default.a.error(function(res){
				});
			}
		},function(response){});
	}
}
//是否在微信
global.isWeiXin=function (){
	var ua = window.navigator.userAgent.toLowerCase();
	if(ua.match(/MicroMessenger/i) == 'micromessenger'){
		return true;
	}else{
		return false;
	}
}
//是否是iphoneX
global.isIphoneX=function(){
    return /iphone/gi.test(navigator.userAgent) && (screen.height == 812 && screen.width == 375)
}

//跳到APPSTORE
global.goToAppStore=function(){
	window.location.href='itms-services://?action=download-manifest&url=https://down.5sm.com/manifest.plist';
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(47)))

/***/ }),

/***/ 161:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
	components: {}
});

/***/ }),

/***/ 162:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_clipboard2__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_clipboard2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_clipboard2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App_vue__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__App_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_routes__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__static_style_css_style_scss__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__static_style_css_style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__static_style_css_style_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_polyfill__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__static_js_util_js__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_hotcss__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_hotcss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_hotcss__);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_clipboard2___default.a);











__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$ajax = __WEBPACK_IMPORTED_MODULE_8_axios___default.a;



var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
	routes: __WEBPACK_IMPORTED_MODULE_4__config_routes__["a" /* default */] });
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].directive('title', {
	inserted: function inserted(el, binding) {
		document.title = binding.value;
	}
});

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
	router: router,
	el: '#app',
	render: function render(h) {
		return h(__WEBPACK_IMPORTED_MODULE_3__App_vue___default.a);
	}
});

/***/ }),

/***/ 375:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(93)(
  /* script */
  null,
  /* template */
  __webpack_require__(377),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 376:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('router-view', {
    staticClass: "view",
    attrs: {
      "keep-alive": "",
      "transition": "",
      "transition-mode": "out-in"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 377:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('router-view')], 1)
},staticRenderFns: []}

/***/ })

},[162]);


// WEBPACK FOOTER //
// static/js/app.e244c35fa2fe41341fec.js